import React from "react";
import "./Confirm_Delivery_Address_Offcanvas.css";
import { Offcanvas } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBuilding } from "@fortawesome/free-solid-svg-icons";
import Gray_Btn from "../../common_components/common_btn/gray_btn/Gray_Btn";
import Blue_Btn from "../../common_components/common_btn/Blue_Btn/Blue_Btn";
import { useNavigate } from "react-router-dom";

const Confirm_Delivery_Address_Offcanvas = ({
  allAddress,
  allBillingAddress,
  setShowModal,
  showModal,
}) => {
  const navigate = useNavigate();

  return (
    <Offcanvas
      className="right_bottom_offcanvas confirm_delivery_address_offcanvas"
      placement="bottom"
      show={showModal}
      onHide={() => {
        setShowModal(false);
      }}
    >
      <Offcanvas.Body>
        <div className="Confirm_Addess_Modal">
          <div className="modal-content">
            <div className="modal-header">
              <div className="title_text">
                <p>Confirm Delivery Address</p>
              </div>

              <div className="right_side">
                <img
                  src="/assets/images/icons/close.png"
                  className="close_img"
                  onClick={() => {
                    setShowModal(false);
                  }}
                />
              </div>
            </div>

            <div className="modal-body">
              <div className="address_holder">
                <p className="type_text">
                  {" "}
                  <FontAwesomeIcon icon={faBuilding} className="inner_icon" />
                  Shipping Address
                </p>

                {allAddress?.data?.length > 0 ? (
                  <p className="address_text">
                    {[
                      allAddress?.data[0]?.building,
                      allAddress?.data[0]?.floor,
                      allAddress?.data[0]?.apartment,
                      allAddress?.data[0]?.street,
                      allAddress?.data[0]?.direction,
                      allAddress?.data[0]?.Users_Address_Detail?.City?.name,
                      allAddress?.data[0]?.Users_Address_Detail?.State?.name,
                      allAddress?.data[0]?.Users_Address_Detail?.Country?.name,
                      allAddress?.data[0]?.Users_Address_Detail?.Pincode?.name,
                    ]
                      .filter(
                        (item) =>
                          item !== null && item !== undefined && item !== "",
                      )
                      .join(", ")}
                  </p>
                ) : (
                  <p className="address_text text-center text-danger">
                    Add Shipping Address
                  </p>
                )}

                <p className="type_text">
                  {" "}
                  <FontAwesomeIcon icon={faBuilding} className="inner_icon" />
                  Billing Address
                </p>

                {allBillingAddress?.data?.length > 0 ? (
                  <p className="address_text">
                    {[
                      allBillingAddress?.data[0]?.building,
                      allBillingAddress?.data[0]?.floor,
                      allBillingAddress?.data[0]?.apartment,
                      allBillingAddress?.data[0]?.street,
                      allBillingAddress?.data[0]?.direction,
                      allBillingAddress?.data[0]?.Users_Address_Detail?.City
                        ?.name,
                      allBillingAddress?.data[0]?.Users_Address_Detail?.State
                        ?.name,
                      allBillingAddress?.data[0]?.Users_Address_Detail?.Country
                        ?.name,
                      allBillingAddress?.data[0]?.Users_Address_Detail?.Pincode
                        ?.name,
                    ]
                      .filter(
                        (item) =>
                          item !== null && item !== undefined && item !== "",
                      )
                      .join(", ")}
                  </p>
                ) : (
                  <p className="address_text text-center text-danger">
                    Add Billing Address
                  </p>
                )}

                {allAddress?.data?.length > 0 &&
                allBillingAddress?.data?.length > 0 ? (
                  <div className="btns_holder">
                    <Gray_Btn
                      btn_name="Update Address"
                      onClick={() => {
                        navigate("/saved-address");
                      }}
                    />
                    <Blue_Btn
                      btnText="Proceed"
                      onClick={() => {
                        navigate("/checkout");
                      }}
                    />
                  </div>
                ) : (
                  <div className="btns_holder">
                    <Gray_Btn
                      btn_name="Add Address"
                      onClick={() => {
                        navigate("/saved-address");
                      }}
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </Offcanvas.Body>
    </Offcanvas>
  );
};

export default Confirm_Delivery_Address_Offcanvas;
